module.exports = __webpack_public_path__ + "img/recipe.82007783.webp";